<template>
  <p class="sectionTitle mb-2">－新規投稿－</p>
  <v-card
    ><v-card-text
      ><v-text-field
        variant="outlined"
        label="タイトル"
        v-model="postTitle"
      ></v-text-field>
      <v-textarea
        clearable
        variant="outlined"
        label="本文"
        v-model="postText"
      ></v-textarea
      ><v-file-input
        clearable
        label="File input"
        variant="outlined"
        accept="image/jpeg, image/png"
        prepend-icon="mdi-camera"
        v-model="fileForPost"
      ></v-file-input>
      <v-row justify="end">
        <v-checkbox v-model="emergency" label="緊急"></v-checkbox>
        <v-checkbox v-model="deliverMail" label="メール配信"></v-checkbox>
        <v-dialog v-model="postDialog" persistent width="auto">
          <template v-slot:activator="{ props }">
            <v-btn color="primary" class="mr-2 mb-2" v-bind="props">投稿</v-btn>
          </template>
          <v-card>
            <v-card-text>この内容で投稿しますか？</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green-darken-1"
                variant="text"
                @click="postDialog = false"
              >
                キャンセル
              </v-btn>
              <v-btn color="green-darken-1" variant="text" @click="postPost()">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-card-text></v-card
  >
</template>

<script>
import Export from "../export";
import store from "../store";
export default {
  name: "DisplayPosts",
  props: {
    msg: String,
  },
  mounted() {
    if (this.loginState == false) {
      this.$router.push("/");
    }
  },
  data() {
    return {
      postTitle: "",
      postText: "",
      emergency: false,
      deliverMail: false,
      postDialog: false,
      fileForPost: [],
    };
  },
  computed: {
    posts: {
      get() {
        return store.state.posts;
      },
      set(value) {
        store.state.posts = value;
      },
    },
    loginState: {
      get() {
        return store.state.loginState;
      },
      set(value) {
        store.state.loginState = value;
      },
    },
    isLoading: {
      get() {
        return store.state.isLoading;
      },
      set(value) {
        store.state.isLoading = value;
      },
    },
  },
  methods: {
    async getPosts() {
      var getPosts = await Export.getPosts();
      this.posts = getPosts.data;
      this.posts = this.posts.sort(function (a, b) {
        return a.timestamp > b.timestamp ? -1 : 1; //オブジェクトの降順ソート
      });
    },
    async postPost() {
      this.isLoading = true;
      let formdata = new FormData();
      var timestamp = Date.now();
      var id = this.getUniqueStr();
      var media = "false";
      if (this.fileForPost.length > 0) {
        media = "true";
      }
      formdata.append("id", id);
      formdata.append("timestamp", timestamp);
      formdata.append("title", this.postTitle);
      formdata.append("text", this.postText);
      formdata.append("emergency", this.emergency);
      formdata.append("deliverMail", this.deliverMail);
      formdata.append("media", media);
      await Export.postPost(formdata);
      await this.getPosts();
      if (this.fileForPost.length > 0) {
        await this.postMedia(id);
      }
      this.postTitle = "";
      this.postText = "";
      this.fileForPost = [];
      this.emergency = false;
      this.deliverMail = false;
      this.postDialog = false;
      this.isLoading = false;
    },
    getUniqueStr(myStrong) {
      var strong = 1000;
      if (myStrong) strong = myStrong;
      return (
        new Date().getTime().toString(16) +
        Math.floor(strong * Math.random()).toString(16)
      );
    },
    async postMedia(id) {
      var file = this.fileForPost[0];
      var filename = file.name;
      let fileType = filename.split(".").pop();
      var timestamp = Date.now();
      var formdata = new FormData();
      formdata.append("id", id);
      formdata.append("file", file);
      formdata.append("fileType", fileType);
      formdata.append("timestamp", timestamp);
      await Export.postMedia(formdata);
    },
    timestampToTime(timestamp) {
      var d = new Date(Number(timestamp));
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    makeShort(txt) {
      var st = txt.substr(0, 12);
      return st + "...";
    },
    showDetail(id) {
      this.detailPanel = true;
      this.detailIndex = id;
    },
    async post() {},
  },
  watch: {
    /*fileForPost() {
      console.log(this.fileForPost);
    },*/
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-card-text {
  font-size: 1rem !important;
}
.v-card-subtitle {
  font-size: 0.9rem !important;
}
.itemList dt {
  font-size: 0.9rem !important;
  color: #7a7a7a;
}
.itemList dd {
  font-size: 1rem !important;
}
.sectionTitle {
  color: #44bd3f;
  text-align: center;
}
</style>
